import { useSubscription } from '@apollo/client/react';
import { getAuthApolloClient } from '@jwp/ott-common/src/graphql/ApolloClient';
import { GET_NOTIFICATION_COUNT } from '@jwp/ott-common/src/graphql/query/notification.queries';
import {
  INCOMING_NOTIFICATION_PAYLOAD,
  NOTIFICATION_EVENT,
  type NotificationEventData,
  type NotificationEventVariables,
} from '@jwp/ott-common/src/graphql/subscription/notification.subscriptions';
import { UNREAD_NOTIFICATION_COUNT_FILTER } from '@jwp/ott-common/src/constants/notifications';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import { GetCookie } from '@jwp/ott-common/src/utils/cookie';

/**
 * Global in-app notification subscription (AppRoutes).
 * On payload "Incoming Notification" with no error → refetch getNotificationCount for bell dot only.
 */
export default function useNotificationEventSubscription() {
  const user = useAccountStore((s) => s.user);
  const accountLoading = useAccountStore((s) => s.loading);
  const accessToken = GetCookie('AccessToken');
  const uId = user?.id ?? '';
  const isEnabled = !!uId && !accountLoading && !!accessToken;

  const client = getAuthApolloClient();

  useSubscription<NotificationEventData, NotificationEventVariables>(NOTIFICATION_EVENT, {
    client,
    variables: { uId },
    skip: !isEnabled,
    onData: ({ data: subscriptionResult }) => {
      const event = subscriptionResult.data?.notificationEvent;
      if (!event) { return; }

      const { payload, error } = event;
      if (error != null || payload !== INCOMING_NOTIFICATION_PAYLOAD) { return; }

      void client.refetchQueries({
        include: [
          {
            query: GET_NOTIFICATION_COUNT,
            variables: { nIsRead: UNREAD_NOTIFICATION_COUNT_FILTER },
          },
        ],
      });
    },
  });
}
